import { Navigate, Outlet, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import Criptografia from "../services/Criptografia";

function ProtectedRoutePrimeiroLogin() {
  const token = Cookies.get("token");
  const location = useLocation();

  const rotaAtual = location.pathname;

  const rotasPermitidasComum = ["/redefinirInformacoes", "/termos"];
  const rotasPermitidasAdmin = ["/redefinir/senha"];

  let primeiroLogin = false;
  let grupoDeUsuarioId = null;

  if (token) {
    const tokenObjeto = JSON.parse(token);
    primeiroLogin = tokenObjeto.primeiroLogin;
    grupoDeUsuarioId = Criptografia.DescriptografarID(tokenObjeto.grupoDeUsuarioId);
  }

  const isAdmin = grupoDeUsuarioId === 1;
  const isComum = [2, 3, 4].includes(grupoDeUsuarioId);

  // Usuário já finalizou o primeiro login -> redireciona se tentar acessar rotas de primeiro login
  if (
    primeiroLogin === false &&
    [...rotasPermitidasComum, ...rotasPermitidasAdmin].includes(rotaAtual)
  ) {
    return <Navigate to="/" replace />;
  }

  // ADMIN no primeiro login: só pode acessar /redefinir/senha
  if (
    isAdmin &&
    primeiroLogin === true &&
    !rotasPermitidasAdmin.includes(rotaAtual)
  ) {
    return <Navigate to="/redefinir/senha" replace />;
  }

  // Usuário comum no primeiro login: só pode acessar /redefinirInformacoes e /termos
  if (
    isComum &&
    primeiroLogin === true &&
    !rotasPermitidasComum.includes(rotaAtual)
  ) {
    return <Navigate to="/redefinirInformacoes" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoutePrimeiroLogin;
